"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/farm/constants.ts
var FARM_OP_CODES = {
  STAKE: 1858722917,
  CLAIM_REWARDS: 2027548937,
  UNSTAKE: 3106497952
};
var FARM_VERSION = {
  v1: "v1",
  v2: "v2",
  v3: "v3"
};




exports.FARM_OP_CODES = FARM_OP_CODES; exports.FARM_VERSION = FARM_VERSION;
//# sourceMappingURL=chunk-JLYOJWE3.cjs.map